import HeaderReport from "../../../Components/ComponentsIndustry/HeaderReport";
import CountUp from "react-countup";
import axios from "axios"
import { useUser } from "../../../providers/UserContext"
import {
  Container,
  SizeContainer,
  PelImg,
  ContainerReport,
  ParagraphValue,
  ParagraphValuePositive,
  NoteFooter,
  DivFooter,
} from "./style";
import { useEffect, useState } from "react";
import Loading from "../../../Components/Loading";

const LossesAndProfits = () => {

  const [loading, setLoading] = useState(false)
  const { user, rodada, industry, jogo } = useUser()
  const aluguel = 250000
  const [profitsAndLosses, setProfitsAndLosses] = useState({});

  useEffect(() => {
    if (!industry?.industria || !jogo?.jogo) return
    fetchLosses()
  }, [industry, jogo])

  const fetchLosses = async () => {
    try {
      setLoading(true)
      const response = await axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/lucroseperdas/obterIndustriaJogo/${industry?.industria}/${jogo?.jogo}`)
      let custos = 0
      let data = {
        receita: 0,
        marketing: 0,
        frete: 0,
        cpf: 0,
        outros: 0,
        custos: 0,
        impostos: 0,
        margemBruta: 0,
        lucroLiquido: 0
      }

      response.data?.forEach(item => {
        if (item.tipo === "VENDA_INDUSTRIA") {
          data.receita += item.total
        } else if (item.tipo === "MARKETING_INDUSTRIA") {
          data.custos += Math.abs(item.total)
          data.marketing = Math.abs(item.total)
        } else if (item.tipo === "LOGISTICA_INDUSTRIA") {
          data.custos += Math.abs(item.total)
          data.frete = Math.abs(item.total)
        } else if (item.tipo === "PRODUCAO") {
          data.custos += Math.abs(item.total)
          data.cpf += Math.abs(item.total)
        } else if (item.tipo === "COMPRA_INDUSTRIA") {
          data.custos += Math.abs(item.total)
          data.cpf += Math.abs(item.total)
        } else if (item.tipo === "OUTROS") {
          data.custos += Math.abs(item.total)
          data.outros += Math.abs(item.total)
        }
      })

      data.impostos = (10 / 100) * data.receita
      data.custos += data.impostos
      data.margemBruta += (data.receita - data.custos)
      data.lucroLiquido += (data.margemBruta - aluguel)
      setProfitsAndLosses(data)

    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false)
    }
  }

  return (
    <Container>
      <SizeContainer>
        <HeaderReport title="P&amp;L" pathImg="./images/pel_button.svg" />
        <PelImg src="./images/pel_img.svg" />
        <ContainerReport>
          {loading ? (
            <Loading />
          ) : (
            <>
              <ParagraphValuePositive>
                <span>
                  Receitas
                </span>
                <span>
                  <CountUp
                    prefix="+ R$"
                    end={profitsAndLosses?.receita}
                    separator="."
                    decimal=","
                    decimals={2}
                    duration={0.5}
                  />
                </span>
              </ParagraphValuePositive>

              <ParagraphValue>
                <span >
                  Impostos
                </span>
                <span>
                  <CountUp
                    prefix="- R$"
                    end={profitsAndLosses?.impostos}
                    separator="."
                    decimal=","
                    decimals={2}
                    duration={0.5}
                  />
                </span>
              </ParagraphValue>

              <ParagraphValue>
                <span>
                  {/* <img src="./images/negative_icon.svg" alt="negative_icon" /> */}
                  Despesas de Marketing
                </span>
                <span>
                  <CountUp
                    prefix="- R$"
                    end={profitsAndLosses?.marketing}
                    separator="."
                    decimal=","
                    decimals={2}
                    duration={0.5}
                  />
                </span>
              </ParagraphValue>

              <ParagraphValue>
                <span>
                  {/* <img src="./images/add_button.svg" alt="add_button" />
                    <img src="./images/negative_icon.svg" alt="negative_icon" /> */}

                  Frete
                </span>
                <span>
                  <CountUp
                    prefix="- R$"
                    end={profitsAndLosses?.frete}
                    separator="."
                    decimal=","
                    decimals={2}
                    duration={0.5}
                  />
                </span>
              </ParagraphValue>

              <ParagraphValue>
                <span>
                  {/* <img src="./images/negative_icon.svg" alt="negative_icon" /> */}
                  CPF (Custo de Produto Fabricado)
                </span>
                <span>
                  <CountUp
                    prefix="- R$"
                    end={profitsAndLosses?.cpf}
                    separator="."
                    decimal=","
                    decimals={2}
                    duration={0.5}
                  />
                </span>
              </ParagraphValue>

              <ParagraphValue style={{ color: profitsAndLosses?.margemBruta < 0 ? "red" : "#222" }}>
                <span>
                  Margem Bruta
                </span>
                <span>
                  <CountUp
                    prefix="R$"
                    end={profitsAndLosses?.margemBruta}
                    separator="."
                    decimal=","
                    decimals={2}
                    duration={0.5}
                  />
                </span>
              </ParagraphValue>

              <ParagraphValue>
                <span>
                  {/* <img src="./images/negative_icon.svg" alt="negative_icon" /> */}
                  Aluguel
                </span>
                <span>
                  <CountUp
                    prefix="- R$"
                    end={aluguel}
                    separator="."
                    decimal=","
                    decimals={2}
                    duration={0.5}
                  />
                </span>
              </ParagraphValue>

              <ParagraphValue>
                <span>
                  {/* <img src="./images/add_button.svg" alt="add_button" />
                    <img src="./images/negative_icon.svg" alt="negative_icon" /> */}

                  Outros
                </span>
                <span>
                  <CountUp
                    prefix="- R$"
                    end={profitsAndLosses?.outros}
                    separator="."
                    decimal=","
                    decimals={2}
                    duration={0.5}
                  />
                </span>
              </ParagraphValue>

              <ParagraphValue style={{ color: profitsAndLosses?.lucroLiquido < 0 ? "red" : "#222" }}>
                <span>
                  Lucro/Prejuízo
                </span>
                <span>
                  <CountUp
                    prefix="R$"
                    end={profitsAndLosses?.lucroLiquido}
                    separator="."
                    decimal=","
                    decimals={2}
                    duration={0.5}
                  />
                </span>
              </ParagraphValue>
            </>
          )

          }


        </ContainerReport>
        <NoteFooter>
          <p>Ponto de Equilibrio</p>
          <span style={{ color: 0 >= 0 ? "" : "red" }}>
            <CountUp
              prefix="R$"
              end={0}
              separator="."
              decimal=","
              decimals={2}
              duration={0.5}
            />
          </span>
        </NoteFooter>
        <DivFooter>
          <img src="./images/img_pel.svg" alt="img_pel" />
        </DivFooter>
      </SizeContainer >
    </Container >
  );
};
export default LossesAndProfits;
